<!-- 活动-立即报名 -->
<template>
	<div class="wrap">

		<div class="header-wrap" ref="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
			</div>
		</div>

		<div class="head">
			<p class="head-title">{{ info.title }}</p>
			<p class="head-row">
				<span class="head-tag">原创</span>
				艾克深科技 搞一下电子汽车
			</p>
			<p class="head-time">{{ info.create_at }}</p>
			<div class="head-box">
				<div class="head-column">
					<p class="font-1">收录于话题</p>
					<p class="font-2">#搞一下TDZ</p>
				</div>
				<p class="back-row">
					5个
					<img src="../assets/back-icon4.png">
				</p>
			</div>
		</div>

    <div class="content-box" v-html="info.content"></div>
		<div class="content-box">
			<img v-for="(item, index) in info.cover_arr" :key="index" :src="item" class="img">
		</div>

		<div class="footer">
			<div class="footer-wrap">
				<ul class="footer-list">
					<li @click="activityTags()">
						<img src="../assets/shou-active.png" class="footer-icon" v-if="info.is_praise === 1">
						<img src="../assets/shou.png" class="footer-icon" v-else>
						<span class="blue" v-if="info.is_praise == 1">{{ info.praise_num }}</span>
						<span class="gray" v-else>{{ info.praise_num }}</span>
					</li>
					<li @click="activityCollect()">
						<img src="../assets/xing-active.png" class="footer-icon" v-if="info.is_collect === 1">
						<img src="../assets/xing.png" class="footer-icon" v-else>
						<span class="blue" v-if="info.is_collect == 1">{{ info.collect_num }}</span>
						<span class="gray" v-else>{{ info.collect_num }}</span>
					</li>
					<li @click="showShare = true">
						<img src="../assets/icon-29.png" class="footer-icon">
            {{ info.transmit_num }}
					</li>
				</ul>
        <button type="button" class="footer-btn" v-if="info.status === 2">
          已结束
        </button>
        <button type="button" class="footer-btn" v-else-if="info.is_apply === 1">
          已报名
        </button>
				<button type="button" class="footer-btn" v-else @click="$router.push(`/activity-sign-up-information?activity_id=${activity_id}`)">
          立即报名
        </button>
			</div>
		</div>

    <!-- 分享弹窗 -->
    <van-popup v-model="showShare" round position="bottom">
      <div class="window">
        <div class="window-top2">
          <button type="button" class="window-btn2" @click="share()">
            <img src="../assets/type-4.png">微信好友
          </button>
          <button type="button" class="window-btn2" @click="share()">
            <img src="../assets/type-3.png">朋友圈
          </button>
        </div>
        <div class="window-btn-box2" @click="showShare = false">
          <button type="button">取消</button>
        </div>
      </div>
    </van-popup>

	</div>
</template>

<script>
import {copy, isWeChatOpen} from "@/common/util";
import {ActivityService} from "@/common/service";
import {Toast} from "vant";

  export default {
		components: {},
		data() {
			return {
        // 是否是微信端打开
        isWeChat: isWeChatOpen(),
        // 显示分享
        showShare: false,
        // 显示微信分享
        showWeChatShare: false,

        activity_id: 0,
        info: {},
			};
		},
		mounted() {
      const option = this.$route.query;
      this.activity_id = option.activity_id || 0;
      if (this.activity_id > 0) {
        this.getDetail();
      }

		},
		methods: {

      getDetail() {
        ActivityService.getActivityDetail({ id: this.activity_id }).then(({ data }) => {
          this.info = data.detail;
        });
      },

      // 点赞
      activityTags() {
        return ActivityService.activityTags({ id: this.activity_id }).then(({ msg, data }) => {
          Toast(msg);
          this.$set(this.info, 'is_praise', data.tags);
          this.$set(this.info, 'praise_num', this.info.praise_num + (this.info.is_praise === 1 ? 1 : -1));
        });
      },

      // 收藏
      activityCollect() {
        return ActivityService.activityCollect({
          id: this.activity_id,
          status: this.info.is_collect === 1 ? 0 : 1, // 收藏状态（0取消收藏【未收藏】，1收藏）
        }).then(({ msg, data }) => {
          Toast(msg);
          this.$set(this.info, 'is_collect', data.status);
          this.$set(this.info, 'collect_num', this.info.collect_num + (this.info.is_collect === 1 ? 1 : -1));
        });
      },

      initShare() {
        const info = this.info;
        let link = location.href;
        if (link.indexOf('activity_id=') < 0) {
          link += '&activity_id=' + this.activity_id;
        }
        const cover = info.cover_arr[0];
        const shareOption = {
          link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
          title: info.name, // 分享标题
          imgUrl: cover.indexOf('http') > -1 ? cover : `http:${cover}`, // 分享图标
          desc: info.content || '', // 分享描述
        };
        // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
        this.$wx.updateAppMessageShareData({
          ...shareOption,
          // 设置成功
          success: () => {}
        });
        // 自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
        this.$wx.updateTimelineShareData({
          ...shareOption,
          // 设置成功
          success: () => {}
        });
      },
      share() {
        this.showShare = false;
        if (this.isWeChat) {
          this.showWeChatShare = true;
          this.initShare();
        } else {
          let link = location.href;
          if (link.indexOf('activity_id=') < 0) {
            link += '&activity_id=' + this.activity_id;
          }
          copy(link);
          Toast('已复制链接到粘贴板');
        }
        // return;
        const params = {
          id: this.info.id,
        }
        ActivityService.activityTransmit(params).then(() => {
          this.info.transmit_num += 1;
        });
      },
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 44px 0 83px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 44px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	/* 新增 */
	.head {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 9px 14px 20px;
		box-sizing: border-box;
	}

	.head-title {
		width: 100%;
		color: #222222;
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 7px;
	}

	.head-time {
		width: 100%;
		color: #999999;
		font-size: 13px;
		margin-top: 7px;
	}

	.head-row {
		width: 100%;
		color: #636789;
		font-size: 14px;
	}

	.head-tag {
		display: inline-block;
		font-size: 10px;
		color: #AEAEAE;
		padding: 0 4px;
		background-color: #F1F1F1;
		border-radius: 2px;
		height: 18px;
		line-height: 18px;
		margin-right: 8px;
		vertical-align: middle;
	}

	.head-box {
		width: 100%;
		background-color: #F7F7F7;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 10px;
		padding: 12px 14px;
		box-sizing: border-box;
		margin-top: 18px;
	}

	.head-column {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.back-row {
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.back-row>img {
		width: 10px;
	}

	.font-1 {
		color: #999999;
		font-size: 13px;
	}

	.font-2 {
		color: #636789;
		font-size: 14px;
		margin-top: 4px;
	}

	.jump-video {
		width: 92px;
		height: 28px;
		line-height: 28px;
		background-color: #2A63F3;
		border-radius: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-size: 14px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}



	.footer {
		width: 100%;
		height: 83px;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: #FFFFFF;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 6px 15px 0 0;
		box-sizing: border-box;
	}

	.footer-wrap {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.footer-list {
		flex: 1;
		display: flex;
		align-items: center;
		margin-right: 20px;
	}

	.footer-list>li {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #222222;
		font-size: 10px;
	}

	.footer-icon {
		height: 18px;
		margin-bottom: 4px;
	}

	.footer-btn {
		width: 135px;
		height: 36px;
		line-height: 36px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		color: #FFFFFF;
		background-color: #2A63F3;
		border-radius: 50px;
	}

	.content-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.img {
		width: 100%;
	}
	
	.blue {
		color: #2A63F3;
		font-size: 10px;
	}
	
	.gray {
		font-size: 10px;
		color: #333333;
	}


  .window {
    width: 100%;
    display: flex;
    flex-direction: column;
    z-index: 99999999;
    background-color: #FFFFFF;
    border-radius: 16px 16px 0 0;
  }

  .window-top2 {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 25px 25px 23px;
    box-sizing: border-box;
  }

  .window-btn2 {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #333333;
    font-size: 13px;
  }

  .window-btn2>img {
    height: 38px;
    margin-bottom: 5px;
  }

  .window-btn-box2 {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px 0 47px;
    box-sizing: border-box;
    border-top: 1px solid #F2F2F2;
  }

  .window-btn-box2>button {
    color: #999999;
    font-size: 16px;
  }
</style>
